import PagePreloader from 'modules/shared/components/loaders/PagePreloader';
import useLoginLayoutImagesQuery from 'modules/shared/hooks/useLoginLayoutImagesQuery';
import { Outlet } from 'react-router-dom';
import { twJoin } from 'tailwind-merge';
import styles from './ForcePasswordLayout.module.scss';
import useCurrentUser from '../main/hooks/useCurrentUser';

const ForcePasswordLayout = () => {
    const loginImagesQuery = useLoginLayoutImagesQuery();

    useCurrentUser();

    if (loginImagesQuery.isLoading) return <PagePreloader />;

    const imageBackgroundStyles = loginImagesQuery.hasImages
        ? {}
        : {
              backgroundImage: 'url("/images/login-image-left.svg"), url("/images/login-image-right.svg")',
              backgroundPosition: '0 0, 100% 100%',
              backgroundSize: '36%, 28%',
          };

    return (
        <div className="relative flex min-h-screen bg-primary bg-no-repeat" style={imageBackgroundStyles}>
            {loginImagesQuery.hasImages && (
                <div className="absolute inset-0 w-full h-full overflow-hidden">
                    <img
                        key={loginImagesQuery.image}
                        className={twJoin(
                            'w-full h-full object-cover object-center transition-all ease-in-out duration-500',
                            styles['image-animation']
                        )}
                        src={loginImagesQuery.image}
                        alt=""
                    />
                    <div className="absolute inset-0 w-full h-full bg-black/40"></div>
                </div>
            )}
            <div className="relative container mx-auto px-6 z-[1]">
                <div className="flex h-full py-16 gap-4">
                    <div className="flex-1 hidden lg:flex flex-col items-start h-full">
                        <img className="h-10" src="/logos/logo-full.svg" alt="" />
                    </div>

                    <div className="flex-1 self-center w-full">
                        <Outlet />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ForcePasswordLayout;
